import { connect } from 'react-redux';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail, fetchCustomerItem, resetIssueInputs } from '../../actions/salesInvoice_actions';
import { fetchCustomerDetail } from '../../actions/customers_actions';
import { createCreditIssue, fetchSalesReturnDetail, setValue, setSaleRowValue, fetchTaxRates } from '../../actions/sales_actions';
import { setDefaultSearchType } from '../../actions/purchaseOrders_actions';
import { fetchItemSalesHistory } from '../../actions/sales_actions';
import CustomerIssueCredit from '../../components/Returns/customerIssueCredit';

let customerIssueCredit = reduxForm({
  form: 'customerIssueCredit',
  validate,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
})(CustomerIssueCredit);

customerIssueCredit = connect(
  state => ({
    initialValues: state.salesInvoice.salesReturnDetail
  })
)(customerIssueCredit)

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = values => {
  const errors = {}
  if (values.Quantity && !isNumeric(values.Quantity)) {
    errors.Quantity = 'Accept number only!'
  }
  if (values.Quantity && (values.Quantity < 0)) {
    errors.Quantity = 'Positive number only!'
  }
  if (values.UnitPrice && !isNumeric(values.UnitPrice)) {
    errors.UnitPrice = 'Accept number only!'
  }
  if (values.UnitPrice && (values.UnitPrice < 0)) {
    errors.UnitPrice = 'Positive number only!'
  }
  if (!values.Deliver_Customer_id) {
    errors.Deliver_Customer_id = 'Required'
  }
  return errors
}

const selector = formValueSelector('customerIssueCredit');

function mapStateToProps(state) {
  const Promo = selector(state, 'Promo');
  const Tax = selector(state, 'Tax');
  const RestockingFee = selector(state, 'RestockingFee');
  const RestockingFeePercentage = selector(state, 'RestockingFeePercentage');
  const Customers = selector(state, 'Customers');
  const Item = selector(state, 'Item');
  const searchValue = selector(state, 'ProductInformation');
  const searchType = selector(state, 'searchType');
  const Quantity = selector(state, 'Quantity');
  const Weight = selector(state, 'Weight');
  const UnitPrice = selector(state, 'UnitPrice');
  const SmallUnitPrice = selector(state, 'SmallUnitPrice');
  const ConvertNum = selector(state, 'ConvertNum');
  const itemNotation = selector(state, 'itemNotation');
  const PostingDate = selector(state, 'PostingDate');
  const SalesID = selector(state, 'Sales_User_id');

  return {
    Promo,
    Tax,
    RestockingFee,
    RestockingFeePercentage,
    Customers,
    Item,
    searchValue,
    searchType,
    Quantity,
    Weight,
    UnitPrice,
    itemNotation,
    PostingDate,
    SalesID,
    SmallUnitPrice,
    ConvertNum,
    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
    salesInvoiceDetail: state.customers.currentCustomerDetail,
    salesReturnDetail: state.salesInvoice.salesReturnDetail,
    //initialValues: state.salesInvoice.salesReturnDetail,
    currentCustomer: state.customers.currentCustomer,
    customerItem: state.salesInvoice.customerItem,
    taxRates: state.salesOrders.taxRates,
    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
    taxRatesError: state.salesOrders.taxRatesError,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse ? state.header.selectedWarehouse.value : null,
    users: state.settings.all,
    salesItemHistory: state.salesOrders.salesItemHistory,
  }
}

export default connect(mapStateToProps, { 
  fetchSalesInvoiceDetail,
  fetchCustomerItem,
  createCreditIssue,
  fetchSalesInvoiceCompletedDetail,
  fetchSalesReturnDetail,
  setValue,
  setSaleRowValue,
  resetIssueInputs,
  setDefaultSearchType,
  fetchCustomerDetail,
  fetchTaxRates,
  fetchItemSalesHistory, 
})(customerIssueCredit);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/customerIssueCredit.jsx